var exports = {
  "pq": "xdde3148b--c26810--info",
  "wm": "xdde3148b--c26810--logo",
  "v": "xdde3148b--c26810--company-link",
};

module.exports = exports;
